import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
} from "@insite/client-framework/HandlerCreator";
import { UpdateCartApiParameter } from "@insite/client-framework/Services/CartService";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    chain,
    UpdateCart,
} from "@insite/client-framework/Store/Pages/CheckoutReviewAndSubmit/Handlers/SetShippingMethod";
import { CarrierDto, ShipViaDto } from "@insite/client-framework/Types/ApiModels";
import { addShippingInfo } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = ApiHandlerDiscreteParameter<
    {
        carrier: CarrierDto;
        shipVia: ShipViaDto;
    },
    UpdateCartApiParameter
>;

export const TriggerAddShippingInfoEvent: HandlerType = props => {
    const session = getSession(props.getState());
    const itemdata = [];
    if (props.apiParameter.cart?.cartLines && props.apiParameter.cart?.cartLines.length) {
        for (let i = 0; i < props.apiParameter.cart?.cartLines.length; i++) {
            itemdata.push({
                item_name: props.apiParameter.cart?.cartLines[i].shortDescription,
                item_id: props.apiParameter.cart?.cartLines[i].erpNumber,
                quantity: props.apiParameter.cart?.cartLines[i].qtyOrdered,
                price: props.apiParameter.cart?.cartLines[i].pricing?.actualPrice,
                item_brand: props.apiParameter.cart?.cartLines[i].brand?.name
                    ? props.apiParameter.cart?.cartLines[i].brand?.name
                    : "",
            });
        }
    }
    addShippingInfo({
        event: "add_shipping_info",
        ecommerce: {
            currency: session?.currency?.currencyCode,
            value: props?.apiParameter?.cart?.orderGrandTotal ?? 0,
            shipping_tier: {
                carrier: props.parameter.carrier.description,
                service: props.parameter.shipVia.description,
            },
            items: itemdata,
        },
    });
};

addToChainAfter(chain, UpdateCart, TriggerAddShippingInfoEvent);